import * as UserAccountsActions from '../actions/user-accounts.action';
import { UserAccount } from '../../../management/models';

export interface State {
  userAccounts: UserAccount[] | null;
  isClientUserAccountsLoading: boolean;
  error: any;
}

export const initialState: State = {
  userAccounts: null,
  isClientUserAccountsLoading: false,
  error: null
};

export function reducer(
  state = initialState,
  action: UserAccountsActions.UserAccountsActionsUnion
): State {
  switch (action.type) {
    case UserAccountsActions.getCurrentClientUserAccounts.type:
      return {
        ...state,
        isClientUserAccountsLoading: true
      };

    case UserAccountsActions.getCurrentClientUserAccountsSuccess.type:
      return {
        ...state,
        userAccounts: action.data,
        isClientUserAccountsLoading: false
      };

    case UserAccountsActions.getCurrentClientUserAccountsFailure.type:
      return {
        ...state,
        error: action.error,
        isClientUserAccountsLoading: false
      };

    default:
      return state;
  }
}

export const getUserAccounts = (state: State) => state.userAccounts;
